import { Empty, Icon } from 'ui';

const InvitationListEmpty = () => (
  <Empty
    description={{
      subtitle: 'All your invitations to upcoming events will appear here',
      title: 'No upcoming invitations',
    }}
    image={<Icon color="secondary" icon="inbox-line" />}
  />
);

export default InvitationListEmpty;
